import { render } from "./impact_ecosystem_section.html?vue&type=template&id=2fe817c6&external"
import script from "./impact_ecosystem_section.js?vue&type=script&lang=js&external"
export * from "./impact_ecosystem_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__